// extracted by mini-css-extract-plugin
export const sectionContainer = "fullWidthBanner-module--sectionContainer--387Gd";
export const sectionFullWidthBanner = "fullWidthBanner-module--sectionFullWidthBanner--dWQJu";
export const circleRight = "fullWidthBanner-module--circleRight--3P-rX";
export const circleLeft = "fullWidthBanner-module--circleLeft--2CliG";
export const contentWrap = "fullWidthBanner-module--contentWrap--18Hhl";
export const bgImage = "fullWidthBanner-module--bgImage--nAuXM";